'use strict';
module.exports = function domImageDimensionCalculator(url) {
	const domImg = new Image();
	return new Promise(function (resolve, reject) {
		domImg.onload = function () {
			resolve({width: domImg.width, height: domImg.height});
		};
		domImg.onerror = function () {
			reject();
		};
		domImg.src = url;
	});
};

